import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { decodeJwtPayload, isJwtExpired } from '../../utils/jwt';
import RegisterInvalidLinkCard from '../../components/authentication/RegisterInvalidLinkCard';
import RegisterSuccessCard from '../../components/authentication/RegisterSuccessCard';
import RegisterCompleteForm from '../../components/authentication/RegisterCompleteForm';

export default function RegisterCompletePage() {
  const { jwtToken } = useParams<{ jwtToken: string }>();

  const tokenPayload = jwtToken ? decodeJwtPayload(jwtToken) : null;
  const email = tokenPayload?.sub;
  const linkValid = Boolean(tokenPayload && email && !isJwtExpired(tokenPayload));

  const [success, setSuccess] = useState(false);

  if (!linkValid) return <RegisterInvalidLinkCard />;
  if (success) return <RegisterSuccessCard />;

  return <RegisterCompleteForm email={email!} onSuccess={() => setSuccess(true)} jwtToken={jwtToken!}/>;
}
